import { Query, Visitor } from 'graphql/generated/graphqlTypes';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';

export function getVisitorByIdDataForQuery(getVisitorById: Visitor): Pick<Query, 'getVisitorById'> {
  return {
    getVisitorById
  };
}

export const mockedGetVisitorByIdDataForQuery = getVisitorByIdDataForQuery(
  generateMockVisitor(
    generateMockVisitor({
      id: 'mockedVisitorIdExternalUser6',
      name: 'mockedVisitorNameExternalUser6',
      email: 'mockedVisitorEmailExternalUser6'
    })
  )
);
